<template>
  <vs-popup class="add-new-incoterms" id="popup" :title="`ACTIONS - ${details.Code}`" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="flex mb-8 vx-card card-border no-shadow p-2">
        <vs-button v-if="!show_available_action_list" v-can="'create-action'" @click="onClickCreate" class="mr-4"
          color="primary" type="filled">New</vs-button>
        <vs-button v-if="!show_available_action_list" v-can="'update-action'" @click="onClickLinkExistingAction"
          class="mr-4" color="primary" type="border">Link Existing Action</vs-button>
        <vs-button v-if="show_available_action_list" v-can="'update-action'" @click="onClickLinkExistingActionBack"
          class="mr-4" color="primary" type="border">Go Back</vs-button>
      </div>

      <vs-table :data="attachments" class="" stripe v-if="!show_available_action_list" pagination max-items="10">
        <template slot="header">
          <h3 class="mb-3">
            Linked Actions
          </h3>
        </template>
        <template slot="thead">
          <vs-th width="10%">Action Category</vs-th>
          <vs-th width="10%">Action Number</vs-th>
          <vs-th width="10%">Location</vs-th>
          <vs-th width="20%">Action Title</vs-th>
          <vs-th width="20%">Person Responsible</vs-th>
          <vs-th width="10%">Status</vs-th>
          <vs-th width="10%">Risk Rating</vs-th>
          <vs-th width="10%"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].ActionCategory">
              {{ data[indextr].ActionCategory }}
            </vs-td>

            <vs-td :data="data[indextr].Code">
              {{ data[indextr].Code }}
            </vs-td>

            <vs-td :data="data[indextr].Location">
              {{ data[indextr].Location ? data[indextr].Location.Name : '' }}
            </vs-td>

            <vs-td :data="data[indextr].ActionTitle">
              {{ data[indextr].ActionTitle }}
            </vs-td>

            <vs-td :data="data[indextr].Action">
              {{ data[indextr].PersonResponsible ? data[indextr].PersonResponsible.Name : '' }}
            </vs-td>

            <vs-td :data="data[indextr].Status">
              {{ data[indextr].Status }}
            </vs-td>

            <vs-td>
              <vs-chip :color="generateRiskRating(data[indextr].Consequence, data[indextr].Likelihood).color">
                {{ generateRiskRating(data[indextr].Consequence, data[indextr].Likelihood).rating }}
              </vs-chip>
            </vs-td>

            <vs-td>
              <div class="flex">
                <vx-tooltip text="Open Action" position="top">
                  <vs-button size="small" @click="onClickOpen(data[indextr]._id)" icon-pack="feather" icon="icon-eye"
                    class="ml-1"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Update Status" position="top">
                  <vs-button size="small" @click="onClickActionEdit(data[indextr])" icon-pack="feather" icon="icon-edit"
                    color="warning" class="ml-1"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Un Link from Assessment" position="top">
                  <vs-button size="small" @click="onClickActionRemove(data[indextr]._id, true)" icon-pack="feather"
                    icon="icon-git-merge" color="danger" class="ml-1" type="border"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Remove" position="top">
                  <vs-button size="small" @click="onClickActionRemove(data[indextr]._id)" icon-pack="feather"
                    icon="icon-trash-2" color="danger" class="ml-1"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>

      </vs-table>

      <vs-table :data="available_actions_to_link" class="" stripe v-if="show_available_action_list" pagination
        max-items="10">
        <template slot="header">
          <h3 class="mb-3">Available Actions to Link</h3>
        </template>
        <template slot="thead">
          <vs-th width="10%">Action Category</vs-th>
          <vs-th width="10%">Action Number</vs-th>
          <vs-th width="10%">Location</vs-th>
          <vs-th width="20%">Action Title</vs-th>
          <vs-th width="20%">Person Responsible</vs-th>
          <vs-th width="10%">Status</vs-th>
          <vs-th width="10%">Risk Rating</vs-th>
          <vs-th width="10%"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].ActionCategory">
              {{ data[indextr].ActionCategory }}
            </vs-td>

            <vs-td :data="data[indextr].Code">
              {{ data[indextr].Code }}
            </vs-td>

            <vs-td :data="data[indextr].Location">
              {{ data[indextr].Location ? data[indextr].Location.Name : '' }}
            </vs-td>

            <vs-td :data="data[indextr].ActionTitle">
              {{ data[indextr].ActionTitle }}
            </vs-td>

            <vs-td :data="data[indextr].Action">
              {{ data[indextr].PersonResponsible ? data[indextr].PersonResponsible.Name : '' }}
            </vs-td>

            <vs-td :data="data[indextr].Status">
              {{ data[indextr].Status }}
            </vs-td>

            <vs-td>
              <vs-chip :color="generateRiskRating(data[indextr].Consequence, data[indextr].Likelihood).color">
                {{ generateRiskRating(data[indextr].Consequence, data[indextr].Likelihood).rating }}
              </vs-chip>
            </vs-td>

            <vs-td>
              <div class="flex">
                <vx-tooltip text="Link Action" position="top">
                  <vs-button size="small" @click="LinkActionToAssessment(data[indextr]._id)" icon-pack="feather"
                    icon="icon-link" class="ml-1"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <CreateObjectPopUp ref="createObjectPopUp" @refreshData="refreshData" />
    <vs-prompt @cancel="() => { status_change_form = {} }" @accept="onClickChangeStatus" @close="activePrompt = false"
      :title="`Action Status Update - ${selected_action_for_update.Code}`" :accept-text="'Confirm'" :color="'primary'"
      :active.sync="activePrompt" :is-valid="isValidReason">
      <div class="vx-row">
        <div class="vx-col w-full mb-3">
          <small class="label">Change To</small>
          <v-select :clearable="true" v-model="status_change_form.status" :reduce="option => option.value"
            :options="action_status_list" label="key" class="w-full">
          </v-select>
        </div>
        <div class="vx-col w-full mb-3">
          <small class="label">Comment</small>
          <vs-textarea v-model="status_change_form.comments" class="w-full custom-textarea" ref="commentsTextarea"
            @input="autoResizeTextarea" @mouseup="captureManualResize" :height="textareaHeight" />
        </div>
        <div class="vx-col w-full mb-3">
          <small class="label">Due Date</small>
          <flat-pickr v-model="status_change_form.DueDate" placeholder="" class="w-full" />
        </div>
      </div>

    </vs-prompt>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import CreateObjectPopUp from "@/components/popups/general/CreateObjectPopUp.vue"
const ObjectRepository = RepositoryFactory.get('object');
const ActionRepository = RepositoryFactory.get('action');

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import { getRiskRating } from '@/constants/utils/riskUtils';

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    details: {
      Code: ''
    },
    assessment_type: '',
    attachments: [],
    dragover: false,
    sortBy: 'date-desc',
    selectedFile: null,
    placeholderImgs: {}, // Track images that failed to load
    selected_action_for_update: {},
    activePrompt: false,
    status_change_form: {
      status: '',
      comments: ''
    },
    action_status_list: [
      { key: 'In Progress', value: 'In Progress' },
      { key: 'Complete', value: 'Complete' },
      { key: 'Outstanding', value: 'Outstanding' },
      { key: 'Not Accepted', value: 'Not Accepted' }
    ],
    object_name: 'action',
    available_actions_to_link: [],
    show_available_action_list: false,
    textareaHeight: 150,
    manualResized: false
  }
}

export default {
  name: 'AssessmentActionsPopUp',
  data() {
    return initialState()
  },
  methods: {
    async refreshData(data) {
      if (data.data.data._id) {
        await this.AddActionToAssessment(data.data.data._id);
        await this.fetchActions()
      }

    },
    async openPopup(details, assessment_type) {
      try {
        await Object.assign(this.$data, initialState());
        Object.assign(this.details, details);
        this.assessment_type = assessment_type;
        await this.fetchActions();
        this.open = true;
      } catch (error) {
        console.log(error);
      }
    },
    async onClickOpen(id) {
      let route = this.$router.resolve({ path: `/pages/actions/${id}` });
      window.open(route.href, '_blank');
    },
    async onClickActionEdit(data) {
      this.open = false
      this.selected_action_for_update = data
      this.status_change_form.DueDate = data.DueDate
      this.activePrompt = true
    },
    async onClickChangeStatus() {
      try {
        await ActionRepository.updateActionStatus(this.object_name, this.selected_action_for_update._id, this.status_change_form)
        this.activePrompt = false
        this.open = true
        this.fetchActions()
        this.status_change_form = {
          status: '',
          comments: ''
        }
      } catch (error) {

      }
    },
    async onClickCreate() {
      await this.$refs.createObjectPopUp.openPopup('action', 'create', this.details ? { Company: this.details.Company } : {})
    },
    async onClickLinkExistingAction() {
      try {
        const { data } = (await ActionRepository.getAvailableActionsToLink(this.object_name, this.details.Company._id)).data;
        this.available_actions_to_link = data.data
        this.show_available_action_list = true
      } catch (error) {

      }
    },
    async onClickLinkExistingActionBack() {
      await this.fetchActions()
      this.show_available_action_list = false
    },
    async LinkActionToAssessment(id) {
      try {
        await this.AddActionToAssessment(id)
        await this.onClickLinkExistingAction()
        this.showSuccessMessage('Action linked to Assessment successfully.')
      } catch (error) {

      }
    },
    async AddActionToAssessment(id) {
      try {
        const assessment_keys = {
          propertyriskassessment: 'PropertyRiskAssessment',
          hazardinspection: 'HazardInspection',
          foodsafetyreport: 'FoodSafetyReport',
          copeassessment: 'CopeAssessment'
        }
        let key = assessment_keys[this.assessment_type];
        console.log({ key })
        let payload = {
          [key]: this.details._id
        }
        await ObjectRepository.updateObject(this.object_name, id, payload)
      } catch (error) {

      }
    },
    async fetchActions() {
      this.$vs.loading();
      try {
        const { data } = (await ActionRepository.getAssessmentActions(this.assessment_type, this.details._id)).data;
        this.attachments = data;
      } catch (e) {
        console.log(e);
      }
      this.$vs.loading.close();
    },
    generateRiskRating(consequence, likelihood) {
      return getRiskRating(consequence, likelihood);
    },
    async onClickActionRemove(id, only_unlink = false) {
      try {
        await ActionRepository.removeActionFromAssessment(id, this.assessment_type, only_unlink)
        await this.fetchActions()
      } catch (error) {

      }
    },
    autoResizeTextarea() {
      this.$nextTick(() => {
        if (this.manualResized) return

        const el = this.getNativeTextarea()
        if (!el) return

        el.style.height = 'auto' // CRITICAL
        const newHeight = el.scrollHeight

        this.textareaHeight = newHeight
      })
    },

    captureManualResize() {
      this.$nextTick(() => {
        const el = this.getNativeTextarea()
        if (!el) return

        this.textareaHeight = el.offsetHeight
        this.manualResized = true
      })
    },

    getNativeTextarea() {
      const ref = this.$refs.commentsTextarea
      if (!ref) return null

      if (ref.$el) {
        return ref.$el.querySelector('textarea')
      }

      return null
    }
  },
  components: {
    flatPickr,
    'v-select': vSelect,
    CreateObjectPopUp
  },
  computed: {
    isValidReason() {
      if (!this.status_change_form.status) {
        return false
      }
      // return this.status_change_form.comments.length > 2;
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-incoterms>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}
</style>
